/*
 * Minimum de grammes (Oud vendu au gramme).
 * Empeche l'ajout au panier et le passage en caisse sous le minimum.
 * Le minimum vient de l'attribut data-min-gram pose par le theme.
 */
(function () {
  const ATTR = 'data-min-gram';
  const MSG = 'data-min-gram-message';
  const SELECTOR = 'input[' + ATTR + ']';

  function minOf(input) {
    const value = parseInt(input.getAttribute(ATTR), 10);
    return isNaN(value) ? 1 : value;
  }

  function valueOf(input) {
    const value = parseInt(input.value, 10);
    return isNaN(value) ? 0 : value;
  }

  function showMessage(container, text) {
    if (!container || !text) return;
    let node = container.querySelector('.rizki-min-gram-error');
    if (!node) {
      node = document.createElement('div');
      node.className = 'rizki-min-gram-error';
      node.setAttribute('role', 'status');
      container.prepend(node);
    }
    node.textContent = text;
  }

  function hideMessage(container) {
    if (!container) return;
    const node = container.querySelector('.rizki-min-gram-error');
    if (node) node.remove();
  }

  /* --- Fiche produit : bloque l'ajout au panier sous le minimum --- */
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      const action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      let input = form.querySelector('input[name="quantity"][' + ATTR + ']');
      const formId = form.getAttribute('id');
      if (!input && formId) {
        input = document.querySelector(
          'input[name="quantity"][form="' + formId + '"][' + ATTR + ']'
        );
      }
      if (!input) return;

      const min = minOf(input);
      const container = input.closest('.product-form__quantity') || form.parentElement;
      if (min <= 1 || valueOf(input) >= min) {
        hideMessage(container);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      input.value = min;
      showMessage(container, input.getAttribute(MSG));
      input.focus();
    },
    true
  );

  /* --- Remonte une quantite trop basse avant que le theme ne l'envoie --- */
  document.addEventListener(
    'change',
    function (event) {
      const input = event.target;
      if (!input || !input.matches || !input.matches(SELECTOR)) return;
      const min = minOf(input);
      if (min <= 1) return;
      const value = valueOf(input);
      if (input.getAttribute('name') === 'updates[]') {
        if (value > 0 && value < min) input.value = min;
      } else if (value < min) {
        input.value = min;
      }
    },
    true
  );

  /* --- Panier et tiroir : bloque le passage en caisse --- */
  function firstInvalidLine() {
    const inputs = document.querySelectorAll(SELECTOR);
    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i];
      if (input.getAttribute('name') !== 'updates[]') continue;
      const min = minOf(input);
      const value = valueOf(input);
      if (min > 1 && value > 0 && value < min) return input;
    }
    return null;
  }

  function markAlreadyDisabled() {
    document.querySelectorAll('.cart__ctas button[name="checkout"]').forEach(function (button) {
      if (button.hasAttribute('disabled') && !button.classList.contains('rizki-min-gram-blocked')) {
        button.dataset.rizkiKeepDisabled = 'true';
      }
    });
  }

  function validateCart() {
    const invalid = firstInvalidLine();
    document.querySelectorAll('.cart__ctas').forEach(function (group) {
      group
        .querySelectorAll('button[name="checkout"], .cart__dynamic-checkout-buttons')
        .forEach(function (node) {
          if (invalid) {
            node.classList.add('rizki-min-gram-blocked');
            if (node.tagName === 'BUTTON') node.setAttribute('disabled', 'disabled');
          } else {
            node.classList.remove('rizki-min-gram-blocked');
            if (node.tagName === 'BUTTON' && node.dataset.rizkiKeepDisabled !== 'true') {
              node.removeAttribute('disabled');
            }
          }
        });
      if (invalid) {
        showMessage(group, invalid.getAttribute(MSG));
      } else {
        hideMessage(group);
      }
    });
  }

  let pending = null;
  function scheduleValidation() {
    if (pending) return;
    pending = window.setTimeout(function () {
      pending = null;
      markAlreadyDisabled();
      validateCart();
    }, 80);
  }

  function start() {
    markAlreadyDisabled();
    validateCart();
    new MutationObserver(scheduleValidation).observe(document.body, {
      childList: true,
      subtree: true,
    });
    document.addEventListener('change', scheduleValidation, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
